import {
  Bot, Server, ShieldCheck, Clapperboard, Cpu, ShoppingBag, Globe, HardDrive, Network, Lock, Wallet,
  ArrowLeftRight, Receipt, DatabaseBackup, Sparkles, Share2, CalendarClock, Inbox, Megaphone, AppWindow,
  Factory, Store, Users, Package, Truck, Boxes, FileSignature, CalendarDays, BarChart3, KeyRound, Settings, TerminalSquare,
  PhoneCall, Building2, Phone, Headphones, MessageCircle, CloudCog, FileInput,
} from "lucide-react";

const MAP = {
  Bot, Server, ShieldCheck, Clapperboard, Cpu, ShoppingBag, Globe, HardDrive, Network, Lock, Wallet,
  ArrowLeftRight, Receipt, DatabaseBackup, Sparkles, Share2, CalendarClock, Inbox, Megaphone, AppWindow,
  Factory, Store, Users, Package, Truck, Boxes, FileSignature, CalendarDays, BarChart3, KeyRound, Settings, TerminalSquare,
  PhoneCall, Building2, Phone, Headphones, MessageCircle, CloudCog, FileInput,
};

export const Icon = ({ name, ...props }) => {
  const C = MAP[name] || Sparkles;
  return <C {...props} />;
};
